import React, { useState, useEffect } from 'react';
import cn from 'classnames';
import Card from '../../../components/Card';
import Dropdown from '../../../components/Dropdown';
import styles from './StudentsInformation.module.sass';
import { getSessionGroups, getSessionGroupMembers } from '../../../services/sessionGroup.service';

const StudentsInformation = ({ sessionData, onInputChange, onDropdownChange, loading }) => {
    const [sessionGroups, setSessionGroups] = useState([]);
    const [selectedSessionGroup, setSelectedSessionGroup] = useState(null);
    const [groupMembers, setGroupMembers] = useState([]);
    const [loadingGroups, setLoadingGroups] = useState(false);
    const [loadingMembers, setLoadingMembers] = useState(false);

    // Charger les groupes de sessions au montage du composant
    useEffect(() => {
        const fetchSessionGroups = async () => {
            setLoadingGroups(true);
            try {
                const result = await getSessionGroups({ page: 1, perPage: 1000 });
                setSessionGroups(result.items || []);
            } catch (error) {
                console.error('Erreur lors du chargement des groupes de sessions:', error);
            } finally {
                setLoadingGroups(false);
            }
        };
        fetchSessionGroups();
    }, []);

    // Charger les membres du groupe de session sélectionné
    useEffect(() => {
        const fetchGroupMembers = async () => {
            if (selectedSessionGroup) {
                setLoadingMembers(true);
                try {
                    const members = await getSessionGroupMembers(selectedSessionGroup.value);
                    setGroupMembers(members || []);
                } catch (error) {
                    console.error('Erreur lors du chargement des membres du groupe:', error);
                } finally {
                    setLoadingMembers(false);
                }
            } else {
                setGroupMembers([]);
            }
        };
        fetchGroupMembers();
    }, [selectedSessionGroup]);

    // Mettre à jour le groupe de session dans les données de session
    useEffect(() => {
        if (selectedSessionGroup) {
            onInputChange('session_id', selectedSessionGroup.value);
        } else {
            onInputChange('session_id', null);
        }
    }, [selectedSessionGroup, onInputChange]);

    // Initialiser le groupe sélectionné si sessionData.session_id existe
    useEffect(() => {
        if (sessionData.session_id && sessionGroups.length > 0 && !selectedSessionGroup) {
            const group = sessionGroups.find(g => g.id === sessionData.session_id);
            if (group) {
                setSelectedSessionGroup({
                    value: group.id,
                    title: group.title
                });
            }
        }
    }, [sessionData.session_id, sessionGroups, selectedSessionGroup]);

    // Préparer les options pour le dropdown des groupes de sessions
    const sessionGroupOptions = sessionGroups.map(group => ({
        value: group.id,
        title: group.title
    }));

    const handleSessionGroupChange = (selectedOption) => {
        setSelectedSessionGroup(selectedOption);
    };

    return (
        <Card 
            className={styles.card} 
            title="Groupe de session"
            classTitle="title-yellow"
        >
            <div className={styles.item}>
                <div className={styles.label}>Sélectionner un groupe de session </div>
                <Dropdown
                    className={styles.dropdown}
                    value={selectedSessionGroup}
                    setValue={handleSessionGroupChange}
                    options={sessionGroupOptions}
                    placeholder={loadingGroups ? "Chargement..." : "Choisir un groupe de session"}
                    disabled={loadingGroups || loading}
                    required
                />
     
            </div>
            
            <div className={styles.divider}></div>

            <div className={styles.actions}>
                <button
                    className={cn("button", styles.button)}
                    type="submit"
                    disabled={loading || !selectedSessionGroup}
                >
                    {loading ? "Création en cours..." : "Créer la session"}
                </button>
            </div>
         </Card>
    );
};

export default StudentsInformation;
